import { render } from "./CardEvent.vue?vue&type=template&id=e448d956"
import script from "./CardEvent.vue?vue&type=script&lang=js"
export * from "./CardEvent.vue?vue&type=script&lang=js"

import "./CardEvent.vue?vue&type=style&index=0&id=e448d956&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__